export default __webpack_public_path__ + "static/media/top_bg.89037f97.png";